import {Injectable} from '@angular/core';
import {BaseService} from 'src/app/shared/service/base.service';
import {Observable, Subject} from 'rxjs';
import {tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TransferOrderService {
  itemsBaseUrl = 'api/v1/transfer-order';
  private _refreshNeeded$ = new Subject<void>();

  constructor(private _base: BaseService) {
  }
  get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  private editItem = null;

  setItem(Order) {
    this.editItem = Order;
  }

  getItem() {
    return this.editItem;
  }


  getOrderDetailsById(id: number){
    return this._base
      .get(`${this.itemsBaseUrl}/${id}`)
  }


  getTransferOrderStatus() {
    return this._base.get('api/v1/transfer-order-status');
  }


  filter(itemObj?): Observable<any> {
    return this._base.post(itemObj, `${this.itemsBaseUrl}/filter`);
  }

  deleteOrder(orderId: number) {
    return this._base.deleteById(`${this.itemsBaseUrl}?id=${orderId}`);
  }

  sentByBranch(branchId: number) {
    return this._base
      .get(`${this.itemsBaseUrl}/sent-per-branch/${branchId}`)
  }

  updateTransfer(obj){
    return this._base.put(obj, `api/v1/transfer-order/change-status`).pipe(
      tap(() => this._refreshNeeded$.next())
    );
  }

  insert(obj): Observable<any> {
    return this._base.post(obj, this.itemsBaseUrl).pipe(
      tap(() => this._refreshNeeded$.next())
    );
  }

  cancelTransferOrder(orderId: number){
    return this._base.patch({}, `${this.itemsBaseUrl}/${orderId}/cancel`);
  }

  postTransferOrder(orderId: number) {
    return this._base.post({}, `${this.itemsBaseUrl}/${orderId}/post`);
  }

  getJournalCreationLog(orderId: number) {
    return this._base.get(`api/v1/journal-creation-log/transactions/${orderId}/with-types?journalSourceCode=INVENTORY&journalTypeCodes=TRANSFER_ORDER,CANCEL_TRANSFER_ORDER`);
  }

  retryJournalFailure(orderId: number) {
    return this._base.post({}, `${this.itemsBaseUrl}/${orderId}/retry-failure-journal`);
  }

  getUnpostedCount(branchIds, months?, years?): Observable<any> {
    const m = months && months.length > 0 ? `&months=${months}` : '';
    const y = years && years.length > 0 ? `&years=${years}` : '';
    return this._base.get(`${this.itemsBaseUrl}/un-posted/count?branchIds=${branchIds}${m}${y}`);
  }

  getUnpostedDetails(branchIds, months?, years?) {
    const m = months ? `&months=${months}` : '';
    const y = years ? `&years=${years}` : '';
    return this._base.get(`${this.itemsBaseUrl}/un-posted/details?branchIds=${branchIds}${m}${y}`);
  }

  bulkPostUnpostedOrders(branchIds, months, years): Observable<any> {
    const m = months ? `&months=${months}` : '';
    const y = years ? `&years=${years}` : '';
    return this._base.post(null, `${this.itemsBaseUrl}/un-posted/bulk-post?branchIds=${branchIds}${m}${y}`);
  }

  getFinancialPeriods(moduleId: number) {
    return this._base.get(`api/v1/period-management/module/${moduleId}?name=`);
  }
}
